import React from 'react';

const SuccessIcon = ({ size = 20, color="#26A69A", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99992 0.333344C3.32659 0.333344 0.333252 3.32668 0.333252 7.00001C0.333252 10.6733 3.32659 13.6667 6.99992 13.6667C10.6733 13.6667 13.6666 10.6733 13.6666 7.00001C13.6666 3.32668 10.6733 0.333344 6.99992 0.333344ZM10.1866 5.46668L6.40658 9.24668C6.31325 9.34001 6.18658 9.39334 6.05325 9.39334C5.91992 9.39334 5.79325 9.34001 5.69992 9.24668L3.81325 7.36001C3.61992 7.16668 3.61992 6.84668 3.81325 6.65334C4.00658 6.46001 4.32658 6.46001 4.51992 6.65334L6.05325 8.18668L9.47992 4.76001C9.67325 4.56668 9.99325 4.56668 10.1866 4.76001C10.3799 4.95334 10.3799 5.26668 10.1866 5.46668Z"
      fill={color}
    />
  </svg>
);

export default SuccessIcon;
